import { isDev } from './core/helper'

export const config = {
    cache_version: 114, // the variable is replaced with the current version (project ./backend/src/offline -place=client)
    site_url: isDev() ? 'http://localhost:3000' : 'https://diet-v2.al19.ru',
    api_url: isDev() ? 'http://127.0.0.1:2727' : 'https://diet-v2.al19.ru',
}